import { apiRequest } from './http';
import type { TemplateVersionSummary, UploadVersionRequest, VersionPreview } from './types';

const versionsPath = (templateId: string) =>
  `/api/manage/templates/${encodeURIComponent(templateId)}/versions`;

export async function listTemplateVersions(templateId: string): Promise<TemplateVersionSummary[]> {
  const response = await apiRequest<{ items?: TemplateVersionSummary[] }>(versionsPath(templateId));
  return response.items ?? [];
}

/** TA-07: shows the token diff an upload would cause, without committing it. */
export async function previewTemplateVersion(
  templateId: string,
  request: UploadVersionRequest
): Promise<VersionPreview> {
  return apiRequest<VersionPreview>(`${versionsPath(templateId)}/preview`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request)
  });
}

export async function uploadTemplateVersion(
  templateId: string,
  request: UploadVersionRequest
): Promise<TemplateVersionSummary> {
  return apiRequest<TemplateVersionSummary>(versionsPath(templateId), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request)
  });
}

export async function setCurrentTemplateVersion(
  templateId: string,
  version: number,
  confirmRemoval?: boolean
): Promise<{ items: TemplateVersionSummary[]; applied: VersionPreview }> {
  const query = confirmRemoval ? '?confirmRemoval=true' : '';
  return apiRequest<{ items: TemplateVersionSummary[]; applied: VersionPreview }>(
    `${versionsPath(templateId)}/${version}/current${query}`,
    { method: 'PUT' }
  );
}

export function templateVersionDownloadUrl(templateId: string, version: number): string {
  return `${versionsPath(templateId)}/${version}/download`;
}
